<div class="verification-letter-container">
    <h3 class="title">Verification Letter</h3>
    <mat-checkbox [formControl]="includeBalance" color="primary">Include Current Balance</mat-checkbox>
    <button type="button" (click)="generateVerificationLetter()" class="download-button" color="primary" mat-flat-button [disabled]="isDownloading$ | async">
        <terra-loader *ngIf="isDownloading$ | async"></terra-loader>
        Download Verification Letter
    </button>
</div>